// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__8rU1t","overlay":"styles_overlay__fY-iY"};